var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentRestaurant)?_c('div',{attrs:{"id":"app"}},[_c('header-menu'),(_vm.visibleHeader && !_vm.isHome())?_c('div',{staticClass:"utils--spacer-header"}):_vm._e(),_c('router-view'),_c('footer-menu'),_c('options')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }